/**
 * Client-side Reputation Utilities
 * For frontend display
 */

/**
 * Get reputation tier visual info
 * @param {number} score - Reputation score (0-100)
 * @returns {Object} { tier, label, color, icon, description }
 */
export function getReputationTier(score) {
  if (score >= 95) {
    return {
      tier: 'legendary',
      label: 'Legendary Player',
      color: '#FFD700',
      icon: '👑',
      description: 'Perfect reputation'
    };
  } else if (score >= 85) {
    return {
      tier: 'excellent',
      label: 'Excellent',
      color: '#4CAF50',
      icon: '⭐',
      description: 'Very reliable player'
    };
  } else if (score >= 70) {
    return {
      tier: 'good',
      label: 'Good',
      color: '#2196F3',
      icon: '👍',
      description: 'Trustworthy player'
    };
  } else if (score >= 50) {
    return {
      tier: 'average',
      label: 'Average',
      color: '#FF9800',
      icon: '⚠️',
      description: 'Some concerns'
    };
  } else if (score >= 30) {
    return {
      tier: 'poor',
      label: 'Poor',
      color: '#F44336',
      icon: '⛔',
      description: 'Unreliable player'
    };
  } else {
    return {
      tier: 'banned',
      label: 'Banned',
      color: '#9C27B0',
      icon: '🚫',
      description: 'Account restricted'
    };
  }
}
